"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SlantedCollectionHightlight = _interopRequireDefault(require("./SlantedCollectionHightlight.html"));

var _Cover = _interopRequireDefault(require("../media/Cover"));

var _TitleName = _interopRequireDefault(require("../media/views/TitleInfo/TitleName"));

var _colorUtility = _interopRequireDefault(require("../../../../lib/colorUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _window = window,
    OverDrive = _window.OverDrive;

var SlantedCollectionHighlight =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(SlantedCollectionHighlight, _Backbone$View);

  function SlantedCollectionHighlight(_ref) {
    var _this;

    var bus = _ref.bus,
        room = _ref.room,
        _ref$isHero = _ref.isHero,
        isHero = _ref$isHero === void 0 ? false : _ref$isHero,
        _ref$titleCountOverri = _ref.titleCountOverride,
        titleCountOverride = _ref$titleCountOverri === void 0 ? null : _ref$titleCountOverri;

    _classCallCheck(this, SlantedCollectionHighlight);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SlantedCollectionHighlight).apply(this, arguments));
    _this.template = _SlantedCollectionHightlight["default"];
    _this._views = [];
    _this.bus = bus;
    _this.room = room;
    _this.isHero = isHero;
    _this.highContrastMode = window.OverDrive.highContrast;
    _this.titleCountOverride = titleCountOverride;
    _this._vertToHorizBreakpointPx = 720;
    _this._coverBlockWidthPercentLarge = 0.58;
    _this._coverBlockWidthPercentageSmall = 1;
    _this._smallGridMaxWidthPx = 555;
    _this._mediumGridMaxWidthPx = 667;
    _this._largeGridMaxWidthPx = 1280;
    _this._coverPlaceholderHtml = '<div tabindex="-1" class="CoverImageContainer placeholder"></div>';
    return _this;
  }

  _createClass(SlantedCollectionHighlight, [{
    key: "render",
    value: function render() {
      this.$el.empty();
      var colors = this.getTitlePanelColors();
      var sizeInfo = this.getGridSize();
      this.$el.empty().append($(this.template({
        coverGridSizeClass: sizeInfo["class"],
        collectionTitle: this.model.get('name'),
        collectionDescription: this.model.get('description'),
        collectionId: this.model.get('id'),
        coversHtml: this.getCoversHtml(),
        bannerBackgroundColor: colors.background,
        bannerTextColor: colors.foreground,
        isHero: this.isHero,
        useFallbackDisplay: this.useFallbackDisplay,
        fallBackGridWidth: sizeInfo.gridWidthFallback
      })));
      this.$el.find('.textBlockInner a').on('mouseover', function (evt) {
        evt.currentTarget.style.color = colors.foregroundHover;
      }).on('mouseout', function (evt) {
        evt.currentTarget.style.color = colors.foreground;
      });
      return this;
    }
  }, {
    key: "getGridSize",
    value: function getGridSize() {
      var xlarge = {
        "class": 'extraLarge',
        numCovers: 39,
        numCoversFallback: 47,
        numTilesFallback: 117,
        gridWidthFallback: 13,
        placeholderIndexes: [4, 5, 6, 7, 8, 9, 10, 11, 12, 18, 19, 20, 21, 22, 23, 24, 25, 26, 33, 34, 35, 36, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 55, 62, 63, 64, 65, 66, 67, 68, 69, 70, 77, 78, 79, 80, 81, 82, 83, 84, 91, 92, 93, 94, 95, 96, 97, 98, 99, 104, 105, 106, 107, 108, 109, 110, 111, 112]
      };
      var large = {
        "class": 'large',
        numCovers: 25,
        numCoversFallback: 25,
        numTilesFallback: 54,
        gridWidthFallback: 9,
        placeholderIndexes: [0, 4, 5, 6, 7, 8, 14, 15, 16, 17, 18, 25, 26, 27, 28, 35, 36, 37, 38, 39, 44, 45, 46, 47, 48, 49, 52, 53]
      };
      var medium = {
        "class": 'medium',
        numCovers: 17,
        numCoversFallback: 21,
        numTilesFallback: 35,
        gridWidthFallback: 7,
        placeholderIndexes: [0, 4, 5, 6, 12, 13, 14, 21, 22, 28, 29, 30, 31]
      };
      var small = {
        "class": 'small',
        numCovers: 12,
        numCoversFallback: 20,
        numTilesFallback: 20,
        gridWidthFallback: 5,
        placeholderIndexes: [0, 10, 15, 16]
      }; // take the max of the available width and height so we don't need to rerender when the device rotates

      var largeDimension = Math.max(window.screen.availWidth, window.screen.availHeight);
      var smallDimension = Math.min(window.screen.availWidth, window.screen.availHeight);
      var landscapeMaxGridWidth = largeDimension < this._vertToHorizBreakpointPx ? largeDimension * this._coverBlockWidthPercentageSmall : largeDimension * this._coverBlockWidthPercentLarge;
      var portraitMaxGridWidth = smallDimension < this._vertToHorizBreakpointPx ? smallDimension * this._coverBlockWidthPercentageSmall : smallDimension * this._coverBlockWidthPercentLarge;
      var maxCoverGridWidth = Math.max(landscapeMaxGridWidth, portraitMaxGridWidth);

      if (maxCoverGridWidth <= this._smallGridMaxWidthPx) {
        return small;
      } else if (maxCoverGridWidth <= this._mediumGridMaxWidthPx) {
        return medium;
      } else if (maxCoverGridWidth <= this._largeGridMaxWidthPx) {
        return large;
      } else {
        return xlarge;
      }
    }
  }, {
    key: "getTitlePanelColors",
    value: function getTitlePanelColors() {
      var backgroundColor;

      if (this.highContrastMode) {
        backgroundColor = _colorUtility["default"].highContrastBlue;
      } else {
        // choose a different cover for the source color when the title block is rendered above the cover grid.
        // The effect is nicer if the source cover is abuts the colored area that matches it.
        var colorSourceTitle = this.model.titleCollection.first();

        if (window.innerWidth < this._vertToHorizBreakpointPx && this.model.titleCollection.length > 2) {
          colorSourceTitle = this.model.titleCollection.at(2);
        }

        var cover = colorSourceTitle.getCover(300);
        backgroundColor = '#a79d99';

        if (this.isHero && OverDrive.colors.primary) {
          backgroundColor = OverDrive.colors.primary;
        } else if (!colorSourceTitle.isPlaceholder && cover && cover.primaryColor) {
          backgroundColor = cover.primaryColor.hex;
        } else {
          backgroundColor = '#a79d99';
        }
      }

      var foregroundColor = _colorUtility["default"].getTextColorFromHex(backgroundColor);

      return {
        background: backgroundColor,
        foreground: foregroundColor,
        foregroundHover: _colorUtility["default"].shadeColorHex(backgroundColor, 0.2)
      };
    } // Render one cover for each available title and then repeat them to reach the
    // desired cover count

  }, {
    key: "getCoversHtml",
    value: function getCoversHtml() {
      this.renderBaseCovers();
      var sizeInfo = this.getGridSize();
      var numRequired = !this.useFallbackDisplay ? sizeInfo.numCovers : sizeInfo.numTilesFallback;
      var results = [];

      while (results.length < numRequired) {
        for (var i = 0; i < this._coverMarkup.length && results.length < numRequired;) {
          if (!this.useFallbackDisplay || !sizeInfo.placeholderIndexes.includes(results.length)) {
            results.push(this._coverMarkup[i]);
            ++i;
          } else {
            // The fallback display mode uses placeholder covers to fill out the parts of the grid
            // that will be clipped off by the parent container.
            results.push(this._coverPlaceholderHtml);
          }
        }
      }

      return results;
    }
  }, {
    key: "renderBaseCovers",
    value: function renderBaseCovers() {
      var _this2 = this;

      this._views.forEach(function (view) {
        return view.remove();
      });

      this._views = [];
      this._coverMarkup = [];
      this.model.titleCollection.each(function (title) {
        if (title.isPlaceholder) {
          _this2._coverMarkup.push(_this2._coverPlaceholderHtml);
        } else {
          var cover = new _Cover["default"]({
            model: title,
            coverWidths: {
              mobile: 200,
              tablet: 300,
              desktop: 400
            },
            isInHero: _this2.isHero
          });
          cover.render(); // we add a hidden title name for screen readers

          var titleName = new _TitleName["default"]({
            model: title
          });

          _this2._coverMarkup.push("".concat(cover.el.innerHTML, " <h3 class=\"hiddenTitleName\">").concat(titleName.el.innerHTML, "</h3>"));

          _this2._views.push(cover);

          _this2._views.push(titleName);
        }
      });
    }
  }, {
    key: "remove",
    value: function remove() {
      this._views.forEach(function (v) {
        return v.remove();
      });

      _get(_getPrototypeOf(SlantedCollectionHighlight.prototype), "remove", this).call(this);
    }
  }, {
    key: "makeHero",
    value: function makeHero() {
      this.isHero = true;
      this.$el.find('.mainBox').addClass('hero');
      var colors = this.getTitlePanelColors();
      this.$el.find('.textBlockOuter').attr('style', "background-color:".concat(colors.background, ";color:").concat(colors.foreground));
    }
  }, {
    key: "toggleTitleVisibility",
    value: function toggleTitleVisibility(isVisible) {
      var title = this.$el.find('.textBlockInner');
      isVisible ? title.removeClass('invisible') : title.addClass('invisible');
    }
  }, {
    key: "desiredTitleCount",
    get: function get() {
      if (this.titleCountOverride) {
        return this.titleCountOverride;
      }

      var sizeInfo = this.getGridSize();
      return this.useFallbackDisplay ? sizeInfo.numCoversFallback : sizeInfo.numCovers;
    }
  }, {
    key: "useFallbackDisplay",
    get: function get() {
      return window.Modernizr && !window.Modernizr.cssgrid;
    }
  }]);

  return SlantedCollectionHighlight;
}(Backbone.View);

exports["default"] = SlantedCollectionHighlight;